import { FC, useEffect, useState } from 'react';
import { FormikHelpers } from 'formik';
import { UpdateAddressInput } from 'lib/home/generated/types/api';
import { useShippingAddressUpdateMutation } from '../../ShippingAddress/ShippingAddress.hooks';
import { ShippingAddressFormModal, ShippingAddressFormModalProps } from './ShippingAddressFormModal';

export interface UpdateShippingAddressModalProps
  extends Omit<ShippingAddressFormModalProps<UpdateAddressInput>, 'onSubmit'> {}

export const UpdateShippingAddressModal: FC<UpdateShippingAddressModalProps> = ({ isOpen, ...props }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const updateMutation = useShippingAddressUpdateMutation({
    onSuccess: () => setIsModalOpen(false)
  });

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  const handleSubmit = (values: UpdateAddressInput, formikHelpers: FormikHelpers<UpdateAddressInput>) =>
    updateMutation.mutate({ updateAddressInput: values });

  return (
    <ShippingAddressFormModal<UpdateAddressInput>
      {...props}
      id={`update-shipping-address-modal-${props.address.id}`}
      isOpen={isModalOpen}
      onSubmit={handleSubmit}
      data-cy="update-shipping-address-modal"
    />
  );
};
